var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-navigation-drawer', {
    attrs: {
      "width": _vm.sidebarWidth,
      "app": "",
      "floating": "",
      "mobile-breakpoint": 1024
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Home'
            }
          }
        }, [_c('v-hover', [_c('v-sheet', {
          staticClass: "d-flex align-center",
          attrs: {
            "tile": "",
            "width": _vm.sidebarWidth,
            "height": _vm.headerHeight,
            "color": "transparent"
          }
        }, [_c('img', {
          staticClass: "ml-4 mr-2",
          attrs: {
            "width": "36",
            "height": "36",
            "contain": "",
            "src": require(_vm.$store.state.darkMode ? '../../assets/logo-dark.svg' : '../../assets/logo.svg')
          }
        }), _c('div', {
          staticClass: "text-left"
        }, [_c('div', {
          staticClass: "font-weight-bold text-uppercase mb-n1"
        }, [_vm._v("Széchenyi Egyetem")]), _c('div', {
          staticClass: "caption"
        }, [_vm._v("Beléptetőrendszer")])])])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "append",
      fn: function () {
        return [_c('v-sheet', {
          staticClass: "d-flex flex justify-center align-center pa-1",
          attrs: {
            "color": "transparent",
            "flat": "",
            "dark": "",
            "height": _vm.footerHeight
          }
        }, [_c('v-btn', {
          attrs: {
            "color": "green",
            "text": "",
            "medium": "",
            "depressed": "",
            "block": !_vm.$store.state.impersonateId
          },
          on: {
            "click": _vm.$logout
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-exit-run")]), _vm._v(" Kijelentkezés ")], 1), _vm.$store.state.impersonateId ? _c('v-tooltip', {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var on = _ref.on,
                attrs = _ref.attrs;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "mr-2",
                attrs: {
                  "color": _vm.$store.state.darkMode ? 'grey lighten-5' : 'grey darken-4',
                  "text": "",
                  "medium": "",
                  "depressed": ""
                },
                on: {
                  "click": _vm.stopImpersonate
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-domino-mask")])], 1)];
            }
          }], null, false, 409521596)
        }, [_c('span', [_vm._v("Megszemélyesítés befejezése")])]) : _vm._e()], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.drawer,
      callback: function ($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c('sidebar-menu', {
    attrs: {
      "items": _vm.menu
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }